import $ from 'jquery';
import Cookies from 'js-cookie';
import Breakpoints from 'breakpoints-js';
import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import {singleIndex} from 'instantsearch.js/es/lib/stateMappings';
import {clearRefinements, configure, panel, queryRuleCustomData, refinementList, stats} from 'instantsearch.js/es/widgets';
import historyRouter from 'instantsearch.js/es/lib/routers/history';
import {connectRange, connectRefinementList, connectSearchBox, connectToggleRefinement} from 'instantsearch.js/es/connectors';
import {createInMemoryCache} from "@algolia/cache-in-memory";
import {createFallbackableCache} from "@algolia/cache-common";
import {createBrowserLocalStorageCache} from "@algolia/cache-browser-local-storage";
import {customPriceRangeSlider} from './algolia/algolia.customPriceRangeSlider';
import {customToggleRefinement} from './algolia/algolia.customToggleRefinement';
import {customInfiniteHits} from './algolia/algolia.customInfiniteHits';
import {customSortBy} from './algolia/algolia.customSortBy';
import {customCurrentRefinements} from './algolia/algolia.customCurrentRefinements';
import {customClearRefinements} from './algolia/algolia.customClearRefinements';
import {customDynamicWidgets} from './algolia/algolia.customDynamicWidgets';
import {customBrandOverview} from './algolia/algolia.customBrandOverview';
import {customAvailableStores} from './algolia/algolia.customAvailableStores';
import {conditionallyRemoveGenderFilter, getAutoComplete, simpleDebounce} from './algolia/algolia.autocomplete';
import {sendPurchaseEvent, sendSearchResultViewedEvent} from './algolia/algolia.tracking';
import aa from 'search-insights';
import intersections from './lsag.intersections';
import lodash from './lsag.lodash';
import utils from './lsag.utils';
import productCarousel from './lsag.productcarouselcomponent';

const algolia = {

    init() {
        const $algoliaFilter = $('#js-filters');
        const $body = $('body');
        sessionStorage.setItem('filterOpen', 'false');

        $.ajax({
            url: ACC.config.encodedContextPath + '/translations/algolia',
            type: 'GET',
            success: function (data) {
                algolia.initAlgolia(data);
            },
            error: function () {
                console.error('cannot get translation for url: ' + ACC.config.encodedContextPath + 'translations/algolia');
            }
        });

        if ($algoliaFilter.length) {
            $algoliaFilter.on('click', '.algolia-panel-collapse-button', function (event, delegated) {
                if (!delegated) {
                    const filterSiblings = $(this).closest('.search-filter-panel').siblings();
                    filterSiblings.find('button[aria-expanded="true"]').attr('aria-expanded', 'true').trigger('click', ['delegate']);
                }
                if ($body.hasClass('algolia-overlay-active')) {
                    if (Breakpoints.is('xs') || Breakpoints.is('sm')) {
                        window.algoliaShowOverlay = true;
                    }
                }
            });

            $body.on('click', function (event) {
                const $target = $(event.target);
                const algoliaClass = typeof ($target[0].className) === 'string' && $target[0].className?.includes('ais-')

                if (algoliaClass || $target.closest('.algolia-filter-panel').length) {
                    return;
                }
                $('#js-filters').find('button[aria-expanded="true"]').trigger('click', ['delegate']);
            });

            $body.on('click', '.js-algolia-overlay-show', function () {
                $body.addClass('algolia-overlay-active');
                window.scrollTo(0, 0);
            });

            $body.on('click', '.js-algolia-overlay-hide', function () {
                $body.removeClass('algolia-overlay-active');
                window.algoliaShowOverlay = false;
            });

            $body.on('click', '.js-algolia-overlay-reset', function () {
                $('#js-clear-refinements').trigger('click');
            });

            $algoliaFilter.on('click', '.js-algolia-filter-close', function (event) {
                event.stopPropagation();
                const $parent = $(event.target).closest('.algolia-filter-panel');

                $parent.find('.algolia-panel-collapse-button ').trigger('click', ['delegate']);
            });

            $algoliaFilter.on('click', '.js-clear-filter', function (event) {
                event.stopPropagation();
                const filter = this.dataset.filter;

                document.querySelector(`#js-clear-refinement_${filter} button`).click();
            });

            $algoliaFilter.on('click', '.js-apply-filter', function (event) {
                event.stopPropagation();
                const filter = this.dataset.filter;

                document.querySelector(`.search-filter-${filter} .algolia-panel-collapse-button`).click();
                if (window.algoliaShowOverlay) {
                    $body.addClass('algolia-overlay-active');
                    window.algoliaShowOverlay = false;
                }
            });

            $body.on('click', '.js-algolia-search-close', function () {
                $(this).closest('.algolia-sort').removeClass('active');
            });

            $('#js-btn-show-more').on('click', function (event) {
                const $target = $(event.currentTarget);

                if ($target.hasClass('algolia-btn-show-more--less')) {
                    $target.removeClass('algolia-btn-show-more--less');
                    $('.search-filter-panel.visible')
                        .removeClass('visible')
                        .addClass('hidden');
                    sessionStorage.setItem('filterOpen', 'false');
                } else {
                    $target.addClass('algolia-btn-show-more--less');
                    $('.search-filter-panel.hidden')
                        .removeClass('hidden')
                        .addClass('visible');
                    sessionStorage.setItem('filterOpen', 'true');
                }
            });

            $body.on('keydown', function (event) {
                if (event.key === 'Escape') {
                    $('#js-filters').find('button[aria-expanded="true"]').trigger('click', ['delegate']);
                }
            });

            /*
            TODO: Check if this is still needed
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const targetOfInterest = mutation.oldValue?.includes('ais-Panel--collapsible');
                    if (!targetOfInterest) {
                        return;
                    }
                    const filterCollapsed = mutation.oldValue?.includes('ais-Panel--collapsed');
                    const filterPanel = mutation.target.closest('.search-filter-panel');
                    if (filterCollapsed) {
                        filterPanel.classList.add('force-visible');
                    } else {
                        filterPanel.classList.remove('force-visible');
                    }

                });
            });
            observer.observe(document.querySelector('#js-filters'), {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true,
                attributeOldValue: true
            });
            */
        }
    },

    initAlgolia(translations) {
        let isPageLoad = true;

        const instantSearchRouter = historyRouter({cleanUrlOnDispose: false});
        const virtualSearchBox = connectSearchBox(() => {
        });
        const virtualRefinementList = connectRefinementList(() => null);
        const virtualToggleRefinement = connectToggleRefinement(() => null);
        const virtualRangeInput = connectRange(() => null);

        if (sessionStorage.getItem('genderPreSelection') !== '') {
            let activeGender = Cookies.get('genderSelection');
            sessionStorage.setItem('genderPreSelection', activeGender);
        }

        // https://www.algolia.com/doc/libraries/sdk/v1/customize#cache-requests-and-responses
        const searchClient = algoliasearch(ACC.config.algolia.apiId, ACC.config.algolia.apiKey, {
            responsesCache: createFallbackableCache({
                caches: [
                    createBrowserLocalStorageCache({
                        key: 'responsesCache',
                        timeToLive: 120,
                    }),
                    createInMemoryCache()
                ],
            }),
            requestsCache: createInMemoryCache({serializable: false})
        })

        const index = searchClient.initIndex(ACC.config.algolia.index);

        let initialUiState = {};

        if ($('body').hasClass('template-pages-search-searchListPage')) {
            if (sessionStorage.getItem('genderPreSelection') !== undefined && sessionStorage.getItem('genderPreSelection') !== '') {
                initialUiState = {
                    initialUiState: {
                        [ACC.config.algolia.index]: {
                            refinementList: {
                                departmentName: [translations['algolia.search.preselect.' + sessionStorage.getItem('genderPreSelection')]]
                            }
                        }
                    }
                };
            }
        }

        index.getSettings().then(settings => {

            const search = instantsearch({
                indexName: ACC.config.algolia.index,
                searchClient,
                routing: {
                    router: instantSearchRouter,
                    stateMapping: singleIndex(ACC.config.algolia.index)
                },
                future: {
                    preserveSharedStateOnUnmount: true
                },
                ...initialUiState
            });

            let hitsPerPage = ACC.config.algolia.hitsPerPage;
            if (hitsPerPage === 0) {
                hitsPerPage = settings.hitsPerPage;
            }

            let options = {};
            let categoryPageId = $('.container.algolia-result').attr('data-category-page-id');
            if (categoryPageId !== '') {
                window.algoliaIsCategoryPage = true;
                options = {
                    filters: 'categoryPageId: \'' + categoryPageId + '\''
                };
            }
            search.addWidgets([
                virtualSearchBox({}),
                configure({
                    hitsPerPage: hitsPerPage,
                    userToken: window.algoliaUserToken,
                    clickAnalytics: existsConsentCookie(algoliaTrackingConsentCookieName),
                    enablePersonalization: existsConsentCookie(algoliaPersonalizationConsentCookieName),
                    ...options
                })
            ]);

            if ($('#queryRuleCustomData').length > 0) {
                search.addWidgets([
                    queryRuleCustomData({
                        container: '#queryRuleCustomData',
                        templates: {
                            default() {
                                return ``;
                            }
                        },

                        transformItems(items) {
                            const match = items.find(data => Boolean(data.redirect));
                            if (match && match.redirect) {
                                window.location.href = match.redirect;
                            }
                            return [];
                        }
                    })
                ]);
            }

            if ($('#stats').length > 0) {
                let foundText = translations['algolia.search.info.products'];
                let noFoundText = translations['algolia.search.info.products.no'];
                let emptySearchText = translations['algolia.search.info.search.empty'];

                search.addWidgets([
                    stats({
                        container: '#stats',
                        templates: {
                            text(data, {html}) {

                                if ($('body').attr('data-ispreviewmode') != 'true') {
                                    if (data.hasNoResults) {
                                        $('.algolia-result').css('display', 'none');
                                        $('.algolia-noresult').css('display', 'block');
                                    } else {
                                        $('.algolia-result').css('display', 'block');
                                        $('.algolia-noresult').css('display', 'none');
                                    }
                                }

                                let text = '';

                                let hits = data.nbHits;
                                if (data.nbSortedHits !== undefined) {
                                    hits = data.nbSortedHits;
                                }

                                if (data.query.trim() === '') {
                                    if (categoryPageId !== '') {
                                        text = '';
                                    } else {
                                        text = emptySearchText.replaceAll('$$numberOfHits$$', hits);
                                    }
                                } else {
                                    if (data.hasNoResults) {
                                        text = noFoundText.replaceAll('$$searchWord$$', data.query);
                                    } else {
                                        text = foundText.replaceAll('$$numberOfHits$$', hits).replaceAll('$$searchWord$$', data.query);
                                    }
                                }

                                return html`${text}`;
                            }
                        }
                    })
                ]);
            }

            if (document.querySelector('#js-category-stats')) {
                search.addWidgets([
                    stats({
                        container: '#js-category-stats',
                        templates: {
                            text(data) {
                                return translations['algolia.search.info.categoryProducts'].replaceAll('$$numberOfHits$$', data.nbHits);
                            },
                        }
                    })
                ]);
            }

            if ($('#stats-no-result').length > 0) {
                search.addWidgets([
                    stats({
                        container: '#stats-no-result',
                        templates: {
                            text(data, {html}) {
                                let text = '';
                                let description = '';
                                if (categoryPageId !== '') {
                                    if (data.query.trim() === '') {
                                        text = translations['algolia.search.info.category.notfound'];
                                        description = translations['algolia.search.info.category.notfound.text'];
                                    } else {
                                        text = translations['algolia.search.info.notfound'].replaceAll('$$searchWord$$', data.query);
                                        description = translations['algolia.search.info.notfound.text'];
                                    }
                                } else {
                                    text = translations['algolia.search.info.notfound'].replaceAll('$$searchWord$$', data.query);
                                    description = translations['algolia.search.info.notfound.text'];
                                }
                                text = `<div class="h2">${text}</div><p>${description}</p>`;

                                return html`${text}`;
                            }
                        }
                    })
                ]);
            }

            if ($('#js-total-results').length > 0) {
                let totalResultsText = translations['algolia.search.filter.button.total.resutls'];
                search.addWidgets([
                    stats({
                        container: '#js-total-results',
                        templates: {
                            text(data, {html}) {
                                let hits = data.nbHits;
                                if (data.nbSortedHits !== undefined) {
                                    hits = data.nbSortedHits;
                                }
                                return html`${totalResultsText.replaceAll('$$numberOfHits$$', hits)}`;
                            }
                        }
                    })
                ]);
            }

            if ($('#js-sorting').length > 0) {
                let items = [];
                ACC.config.algolia.sortOptions.split(';').map(function (option) {
                    let indexSuffix = '';
                    if (option !== 'default') {
                        indexSuffix = '_' + option;
                    }
                    let newItem = [
                        {
                            label: translations['algolia.sort.option.' + option],
                            value: ACC.config.algolia.index + indexSuffix
                        }
                    ];
                    items = items.concat(newItem);
                });

                search.addWidgets([
                    customSortBy({
                        container: document.querySelector('#js-sorting'),
                        items: items,
                        translations: translations
                    })
                ]);

                search.addWidgets([
                    customSortBy({
                        container: document.querySelector('#js-sorting-mobile'),
                        items: items,
                        translations: translations
                    })
                ]);
            }

            if ($('#js-filters').length > 0) {
                let widgets = [];

                settings.attributesForFaceting.map(function (filter) {
                    let searchable = false;
                    let filterOpened = false;
                    let filterWidget = '';
                    let filterConfig = undefined;

                    if (filter.includes('searchable')) {
                        searchable = true;
                    }

                    filter = filter.replaceAll('searchable(', '')
                        .replaceAll('afterDistinct(', '')
                        .replaceAll('filterOnly(', '')
                        .replaceAll(')', '');

                    filterConfig = JSON.parse(ACC.config.algolia.filterOptions)[filter];
                    if (filterConfig !== undefined) {
                        filterOpened = filterConfig.opened;
                        filterWidget = filterConfig.widget;
                    }
                    // TODO: functionality can be removed
                    filterOpened = false

                    switch (filterWidget) {
                        case 'toggleRefinement':
                            search.addWidgets([
                                virtualToggleRefinement({attribute: filter})
                            ]);
                            break;
                        case 'priceRangeSlider':
                            search.addWidgets([
                                virtualRangeInput({attribute: filter})
                            ]);
                            break;
                        default:
                            search.addWidgets([
                                virtualRefinementList({attribute: filter})
                            ]);
                            break;
                    }

                    widgets[filter] = algolia.getFilterItem(filter, searchable, translations, settings.maxValuesPerFacet, filterOpened, filterWidget);

                    // Create hidden buttons to clear a filter-attribute
                    const fakeClearButton = document.createElement('div');
                    fakeClearButton.id = 'js-clear-refinement_' + filter.replaceAll('.', '_');
                    document.querySelector('#js-hidden-refinements').appendChild(fakeClearButton);
                    search.addWidgets([
                        clearRefinements({
                            container: document.querySelector('#js-clear-refinement_' + filter.replaceAll('.', '_')),
                            includedAttributes: [filter]
                        })
                    ]);
                });

                search.addWidgets([
                    customDynamicWidgets({
                        container: document.querySelector('#js-filters'),
                        widgets: Object.values(widgets).map(({widget, container}) =>
                            widget(container)
                        ),
                        widgetArray: widgets,
                        hideAfter: parseInt(ACC.config.algolia.filterHideAfter),
                        translations: translations,
                        maxValuesPerFacet: settings.maxValuesPerFacet
                    })
                ]);
            }

            if ($('#current-refinements-desktop').length > 0) {
                if ($('#current-refinements-desktop').length > 0) {
                    search.addWidgets([
                        customCurrentRefinements({
                            container: document.querySelector('#current-refinements-desktop'),
                            translations: translations
                        })
                    ]);
                }
            }

            if ($('#js-clear-refinements').length > 0) {
                search.addWidgets([
                    customClearRefinements({
                        container: document.querySelector('#js-clear-refinements'),
                    })
                ]);
            }

            if ($('#product-grid').length > 0) {
                search.addWidgets([
                    customInfiniteHits({
                        container: document.querySelector('#product-grid'),
                        escapeHTML: false,
                        translations: translations
                    })
                ]);
            }

            if ($('body').hasClass('template-pages-search-searchListPage') || $('body').hasClass('template-pages-category-productListPage')) {
                search.start();
            }

            search.on('render', () => {
                if (search.status === 'idle') {
                    if (isPageLoad) {
                        isPageLoad = false;
                        setTimeout(() => {
                            $('#js-algolia-loading').remove();
                        }, 100);

                        const setProductCellHeight = () => {
                            const productCell = document.querySelector('#masonry-grid .productcell');
                            const root = document.documentElement;

                            if (productCell) {
                                root.style.setProperty('--pc-height', 'auto');
                                const height = productCell.getBoundingClientRect().height;
                                root.style.setProperty('--pc-height', `${height}px`);
                            }
                        }
                        setProductCellHeight();
                        window.addEventListener('resize', lodash.throttle(setProductCellHeight, 500));
                    } else {
                        try {
                            if (angular !== undefined) {
                                let angularWishlist = angular.element('#product-grid').scope();
                                if (angularWishlist !== undefined) {
                                    angularWishlist.wishlist.$rootScope.$broadcast('loadAlgoliaProductsSuccess');
                                }
                                let favouritePos = angular.element('#algolia-rendered-filters').scope();
                                if (favouritePos !== undefined) {
                                    if ($("#favourite-store-button").length === 0) {
                                        //set the reference for the angularJS part
                                        window.instantSearch = search;

                                        $("#js-filters").prepend(`
                                        <div class="search-filter-panel">
                                            <div class="ais-Panel">
                                                <div class="ais-Panel-body">
                                                    <div class="ais-ToggleRefinement">
                                                        <label class="ais-ToggleRefinement-label wcag-focus">
                                                            <input id="favourite-store-button" data-init="true" class="ais-ToggleRefinement-checkbox" type="checkbox">
                                                            <span class="ais-ToggleRefinement-labelText">
                                                                ${translations['algolia.search.filter.favourite.label']}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>`);
                                        favouritePos.favouriteStore.$rootScope.$broadcast('favouriteStoreButtonRendered');
                                    }
                                    favouritePos.favouriteStore.$rootScope.$broadcast('favouriteStoreFilterBoxRendered');
                                }
                            }

                        } catch (e) {
                            console.error('In SmartEdit no angular');
                        }

                        $('.ais-RefinementList-list').each(function () {
                            let count = $(this).children().length;
                            if (count <= parseInt(ACC.config.algolia.filterSearchShowMinvalue)) {
                                $(this).closest('.search-filter-panel').find('.ais-RefinementList-searchBox').addClass(
                                    'ais-RefinementList-searchBox--hidden');
                            } else {
                                $(this).closest('.search-filter-panel').find('.ais-RefinementList-searchBox').removeClass(
                                    'ais-RefinementList-searchBox--hidden')
                            }
                        });
                        sendSearchResultViewedEvent(hitsPerPage);

                        const executeGenderRemovalCheck = simpleDebounce(
                            (search, translations) => conditionallyRemoveGenderFilter(search, translations), 300);
                        executeGenderRemovalCheck(search, translations);
                    }

                    setTimeout(() => {
                        const hideAfter = parseInt(ACC.config.algolia.filterHideAfter);
                        const filterOpen = sessionStorage.getItem('filterOpen');
                        let realRenderedFilters = 0;
                        $('#js-filters .search-filter-panel').each(function (index, element) {
                            const $element = $(element);

                            if ($element.find('.ais-Panel[hidden]').length) {
                                $element.remove();
                            } else {
                                realRenderedFilters++;
                                if (filterOpen === 'true') {
                                    if (realRenderedFilters > hideAfter) {
                                        $element.addClass('visible');
                                    } else {
                                        $element.removeClass('visible');
                                    }
                                } else {
                                    if (realRenderedFilters <= hideAfter) {
                                        $element.removeClass('hidden');
                                    } else {
                                        $element.addClass('hidden');
                                    }
                                }
                            }
                        });

                        const hiddenFacets = $('.search-filter-panel.hidden').length;
                        const visibleFacets = $('.search-filter-panel.visible').length;
                        const showMoreButton = document.querySelector('#js-btn-show-more');
                        if (hiddenFacets || visibleFacets) {
                            showMoreButton.classList.replace('d-none', 'd-flex');
                        } else {
                            showMoreButton.classList.replace('d-flex', 'd-none');
                        }
                    }, 50);

                    if (intersections.intersectionList.length) {
                        this.addIntersections();
                    }
                }
            });

            if ($('#product-grid').length > 0) {
                $(document).on('click', '.ais-RefinementList-label input', function () {
                    if ($(this).hasClass('departmentName') > 0) {
                        if (!$(this).is(':checked')) {
                            sessionStorage.setItem('genderPreSelection', '');
                        }
                    }
                    let $label = $(this).closest('label');
                });

                $(document).on('click', '.product__wishlist-cta.algolia', function () {
                    let wishlist = angular.element('#product-grid').scope().wishlist;
                    let itemCode = $(this).data('item-code');
                    let queryID = $(this).data('queryid');
                    let connectedObjectIds = $(this).data('connectedobjectids');
                    let objectID = $(this).data('objectid');
                    wishlist.setWishlistStateAlgolia(itemCode, queryID, objectID, connectedObjectIds);
                });
            }
            /**** autocomplete ****/
            if ($('.c-main-search').length > 0) {
                function debounce(fn, time) {
                    let timerId = undefined;

                    return function (...args) {
                        if (timerId) {
                            clearTimeout(timerId);
                        }

                        timerId = setTimeout(() => fn(...args), time);
                    };
                }

                function setInstantSearchUiState(indexUiState) {
                    search.setUiState(uiState => ({
                        ...uiState,
                        [ACC.config.algolia.index]: {
                            ...uiState[ACC.config.algolia.index],
                            page: 1,
                            ...indexUiState
                        }
                    }));
                }

                const debouncedSetInstantSearchUiState = debounce(setInstantSearchUiState, ACC.config.algolia.debounceMillisSearch || 0);

                function getInstantSearchUiState() {
                    return instantSearchRouter.read();
                }

                const searchPageState = getInstantSearchUiState();

                let skipInstantSearchUiStateUpdate = false;

                function getSkipInstantSearchUiStateUpdate() {
                    return skipInstantSearchUiStateUpdate;
                }

                function setSkipInstantSearchUiStateUpdate(noUpdate) {
                    skipInstantSearchUiStateUpdate = noUpdate;
                }

                let autocompleteSettings = {};

                let autocompleteSettingsMobile = {
                    container: '.c-main-search.mobile'
                };
                let autocompleteSettingsDesktop = {
                    container: '.c-main-search.desktop'
                };

                if (Breakpoints.is('xs') || Breakpoints.is('sm')) {
                    autocompleteSettings = autocompleteSettingsMobile;
                } else {
                    autocompleteSettings = autocompleteSettingsDesktop;
                }

                let autocomplete = getAutoComplete(instantSearchRouter, searchClient, searchPageState, setInstantSearchUiState,
                    debouncedSetInstantSearchUiState,
                    getSkipInstantSearchUiStateUpdate, setSkipInstantSearchUiStateUpdate, translations, autocompleteSettings);

                Breakpoints.on('xs sm', {
                    enter: function () {
                        autocomplete.destroy();
                        autocomplete = getAutoComplete(instantSearchRouter, searchClient, searchPageState, setInstantSearchUiState,
                            debouncedSetInstantSearchUiState,
                            getSkipInstantSearchUiStateUpdate, setSkipInstantSearchUiStateUpdate, translations, autocompleteSettingsMobile);
                        // OPTIMIZE: Maybe this 'WCAG topics' applied later are also needed after a breakpoint change
                    },
                    leave: function () {
                        window.algoliaShowOverlay = false;
                        autocomplete.destroy();
                        autocomplete = getAutoComplete(instantSearchRouter, searchClient, searchPageState, setInstantSearchUiState,
                            debouncedSetInstantSearchUiState,
                            getSkipInstantSearchUiStateUpdate, setSkipInstantSearchUiStateUpdate, translations, autocompleteSettingsDesktop);
                    }
                });

                window.addEventListener('popstate', () => {
                    setSkipInstantSearchUiStateUpdate(true);
                    autocomplete.setQuery(search.helper?.state.query || '');
                });

                // WCAG topics
                const searchButtons = document.querySelectorAll('.js_search_button');
                const searchInputs = document.querySelectorAll('.c-main-search__input');
                searchButtons?.forEach(button => {
                    button.setAttribute('tabindex', '-1');
                });
                searchInputs?.forEach(input => {
                    input.setAttribute('aria-label', translations['algolia.search.filter.search.ariaLabel']);
                });
            }
            /**** autocomplete end ****/

            /**** brand overview ****/

            if ($('#algoliaBrandOverview').length > 0) {
                const brands = instantsearch({
                    indexName: ACC.config.algolia.index,
                    searchClient
                });

                brands.addWidgets([
                    customBrandOverview({
                        container: document.querySelector('#algoliaBrandOverview'),
                        attribute: 'brandForBrandOverview',
                        sortBy: ['name:asc'],
                        limit: 1000,
                        minCountOfProducts: $('#algoliaBrandOverview').attr('data-min-count-of-products')
                    })
                ]);

                brands.start();
            }
        });
    },
    getFilterItem(filter, searchable, translations, maxValuesPerFacet, filterOpened, filterWidget) {

        if (Breakpoints.is('xs') || Breakpoints.is('sm')) {
            filterOpened = false;
        }

        let panelCssClasses = {
            root: 'algolia-filter-panel',
            header: 'algolia-filter-panel-header',
            body: 'algolia-filter-panel-body',
            footer: 'algolia-filter-panel-footer',
            collapseButton: 'btn btn-filter algolia-panel-collapse-button'
        };

        let panelTemplates = {
            header(options, {html}) {
                return html`
                    <div class="js-algolia-filter-close algolia-filter-panel-backdrop"></div>`;
            },
            collapseButtonText(options, {html}) {
                return html`
                    <div class="algolia-panel-filter-name">
                        ${translations['algolia.search.filter.title.' + filter]}
                        <div class="algolia-panel-filter-counter algolia-panel-filter-counter-${filter.replaceAll('.', '_')}"></div>
                        <div class="algolia-panel-filter-selection algolia-panel-filter-selection-${filter.replaceAll('.', '_')}"></div>
                    </div>
                    <div class="algolia-accordion-icon"></div>
                    <div class="algolia-accordion-icon-right">
                        <svg class="icon">
                            <use xlink:href="#icon-arrow-right"></use>
                        </svg>
                    </div>
                `;
            },
            footer(options, {html}) {
                return html``;
            }
        };

        let panelOptions = {
            cssClasses: panelCssClasses,
            templates: panelTemplates,
            collapsed: ({state}) => {
                // TODO: check if still in use & needed
                return true;
                // return algolia.isFilterCollapsed(state, filterOpened);
            },
            hidden(options) {
                const facetValues = options.results.getFacetValues(filter);
                return Array.isArray(facetValues) ? facetValues.length <= parseInt(ACC.config.algolia.filterShowMinvalue) : false;
            }
        };

        let container = document.createElement('div');
        container.className = 'search-filter-panel search-filter-' + filter;

        let item = null;
        switch (filterWidget) {
            case 'toggleRefinement':
                item = {
                    widget: container => panel({
                        hidden(options) {
                            const facetValues = options.results.getFacetValues(filter);

                            return Array.isArray(facetValues) ? facetValues.length <= ACC.config.algolia.filterShowMinValueToggle : false;
                        }
                    })(customToggleRefinement)({
                        container,
                        attribute: filter,
                        translations: translations,
                        templates: {
                            labelText({count}, {html}) {
                                return html`${translations['algolia.search.filter.title.' + filter]}`;
                            }
                        }
                    }),
                    container: container
                };
                break;
            case 'priceRangeSlider':
                item = {
                    widget: container => panel(
                        panelOptions
                    )(customPriceRangeSlider)({
                        container,
                        attribute: filter,
                        translations: translations
                    }),
                    container: container
                };
                break;
            case 'refinementListPartner':
                item = {
                    widget: container => panel(
                        panelOptions
                    )(refinementList)({
                        container,
                        attribute: filter,
                        searchable: searchable,
                        limit: maxValuesPerFacet,
                        searchablePlaceholder: translations['algolia.search.filter.search.placeholder.' + filter],
                        cssClasses: {
                            checkbox: filter
                        },

                        templates: {
                            item(item, {html}) {
                                const {value, label, count, isRefined} = item;
                                // HACK: switched from <label> to <div> to avoid the browser (default behavior) jumping in the viewport
                                return html`
                                    <div class="ais-RefinementList-label" data-filter="${filter}"
                                         data-value="${value}">
                                        <input type="checkbox" class="ais-RefinementList-checkbox size" value="${value}"/>
                                        <span class="ais-RefinementList-labelText">${translations['algolia.search.filter.title.isPartnerProduct.'
                                        + label]}<span
                                                class="ais-RefinementList-count">${count}</span></span>
                                    </div>`;
                            }
                        }

                    }),
                    container: container
                };
                break;
            case 'refinementListStores':
                item = {
                    widget: container => panel(
                        panelOptions
                    )(customAvailableStores)({
                        container,
                        attribute: filter,
                        searchable: searchable,
                        limit: maxValuesPerFacet,
                        translations: translations,
                        searchablePlaceholder: translations['algolia.search.filter.search.placeholder.' + filter]
                    }),
                    container: container
                };
                break;
            case 'refinementListColor':
                container.className = 'search-filter-panel search-filter-' + filter.replaceAll('.', '_') + ' refinementListColor';
                item = {
                    widget: container => panel(
                        panelOptions
                    )(refinementList)({
                        container,
                        attribute: filter,
                        searchable: searchable,
                        limit: maxValuesPerFacet,
                        searchablePlaceholder: translations['algolia.search.filter.search.placeholder.' + filter],
                        cssClasses: {
                            checkbox: filter
                        },

                        templates: {
                            item(item, {html}) {
                                const {value, label, count, isRefined} = item;
                                let colorArray = value.split(';');
                                let style = 'background-color: ' + colorArray[1];
                                let isWhite = undefined;
                                if (colorArray.length === 3) {
                                    style += ';' + colorArray[2];
                                }
                                if (colorArray[1].toLowerCase() === '#ffffff') {
                                    isWhite = true;
                                }
                                return html`
                                    <div class="ais-RefinementList-label" data-filter="${filter}"
                                         data-value="${value}">
                                        <input type="checkbox" class="ais-RefinementList-checkbox ${filter}"
                                               value="${value}"/>
                                        <div class="ais-RefinementList-color ${isWhite ? 'ais-RefinementList-color--white' : ''}"
                                             style="${style}"></div>
                                        <div class="ais-RefinementList-labelText">${colorArray[0]}</div>
                                    </div>`;
                            }
                        }

                    }),
                    container: container
                };
                break;
            case 'refinementListSize':
                container.className = 'search-filter-panel search-filter-' + filter + ' refinementListSize';
                item = {
                    widget: container => panel(
                        panelOptions
                    )(refinementList)({
                        container,
                        attribute: filter,
                        searchable: searchable,
                        limit: maxValuesPerFacet,
                        searchablePlaceholder: translations['algolia.search.filter.search.placeholder.' + filter],
                        cssClasses: {
                            checkbox: filter
                        },

                        templates: {
                            item(item, {html}) {
                                const {value, label, count, isRefined} = item;
                                return html`
                                    <div class="ais-RefinementList-label" data-filter="${filter}"
                                         data-value="${value}">
                                        <input type="checkbox" class="ais-RefinementList-checkbox ${filter}"
                                               value="${value}"/>
                                        <div class="ais-RefinementList-labelText">${label}</div>
                                    </div>`;
                            }
                        }

                    }),
                    container: container
                };
                break;
            default:
                item = {
                    widget: container => panel(
                        panelOptions
                    )(refinementList)({
                        container,
                        attribute: filter,
                        searchable: searchable,
                        limit: maxValuesPerFacet,
                        searchablePlaceholder: translations['algolia.search.filter.search.placeholder.' + filter],
                        cssClasses: {
                            checkbox: filter
                        },
                        templates: {
                            // https://www.algolia.com/doc/api-reference/widgets/refinement-list/js#templates
                            item(item, {html}) {
                                const {value, label, count, isRefined} = item;
                                return html`
                                    <div class="ais-RefinementList-label" data-filter="${filter}"
                                         data-value="${value}">
                                        <input type="checkbox" class="ais-RefinementList-checkbox ${filter}"
                                               value="${value}"/>
                                        <span class="ais-RefinementList-labelText">${label}<span
                                                class="ais-RefinementList-count">${count}</span></span>
                                    </div>`;
                            },
                            searchableNoResults(data, {html}) {
                                return html`
                                    <div class="ais-RefinementList-noResults">${translations['algolia.search.filter.noResults']}</div>`;
                            },
                        }
                    }),
                    container: container
                };
                break;
        }
        return item;
    },

    isFilterCollapsed(state, filterOpened) {
        if (filterOpened) {
            return false;
        } else {
            return state.query.length === 0;
        }
    },

    initUpdateTracking(tracking, personalization) {
        if (tracking) {
            if (window.aa === undefined) {
                window.aa = aa;
                aa('init', {
                    appId: ACC.config.algolia.apiId,
                    apiKey: ACC.config.algolia.apiKey,
                    useCookie: personalization
                });
                if (personalization) {
                    window.algoliaPersonalization = true;
                } else {
                    deleteConsentCookie('_ALGOLIA');
                    window.algoliaPersonalization = false;
                }
            } else {
                window.aa('init', {
                    partial: true,
                    useCookie: personalization
                });
                if (personalization) {
                    window.algoliaPersonalization = true;
                } else {
                    deleteConsentCookie('_ALGOLIA');
                    window.algoliaPersonalization = false;
                }
            }
        } else {
            window.aa = undefined;
            window.algoliaUserToken = undefined;
            window.algoliaPersonalization = undefined;
            deleteConsentCookie('_ALGOLIA');
        }

        if (window.aa !== undefined) {
            aa('getUserToken', {}, (err, userToken) => {
                if (err) {
                    console.error(err);
                    return;
                }
                window.algoliaUserToken = userToken;
            });
        }
    },
    addIntersections() {
        utils.logger.log('Adding intersections ...');
        const visibleProducts = document.querySelectorAll('.masonry-grid__item');
        const wishlistScope = window.angular ? $('#product-grid').scope().wishlist : undefined;

        intersections.intersectionList.forEach((item) => {
            if (item.pos === 0) {
                console.debug('position of 0 is not supported ...');
                return;
            }
            if (item.pos > visibleProducts.length) {
                return;
            }
            const intersection = document.createElement('li');
            let spacer = null;
            let shadowRoot = null;

            switch (item.type) {
                case 'CMSPlainHtmlComponent':
                    intersection.classList.add('masonry-grid__item', 'masonry-grid__intersection', 'masonry-grid__intersection-html',
                        `span-${item.width}`, `${item.id}`);
                    const dummy = document.createElement('div');
                    dummy.innerHTML = item.html;
                    const dyScript = dummy.querySelector('dy-script');

                    if (dyScript) {
                        dyScript.remove();
                    }

                    // different behaviour for full width components
                    spacer = document.createElement('div');
                    spacer.classList.add('masonry-grid__spacer');
                    spacer.innerHTML = dummy.innerHTML;

                    intersection.appendChild(item.width < 4 ? spacer : dummy);
                    item.styles?.forEach((styleText) => {
                        const styleNode = document.createElement('style');
                        styleNode.textContent = styleText;
                        intersection.appendChild(styleNode);
                    });

                    if (dyScript) {
                        eval(dyScript.textContent);
                    }
                    break;
                case 'ProductCarouselComponent':
                    intersection.classList.add('masonry-grid__item', 'masonry-grid__intersection-carousel', `${item.id}`);
                    intersection.innerHTML = item.html;
                    item.styles?.forEach((styleText) => {
                        const styleNode = document.createElement('style');
                        styleNode.textContent = styleText;
                        intersection.appendChild(styleNode);
                    });
                    break;
                default:
                    intersection.classList.add('masonry-grid__item', 'masonry-grid__intersection', `span-${item.width}`);
                    spacer = document.createElement('div');
                    spacer.classList.add('masonry-grid__spacer');
                    shadowRoot = spacer.attachShadow({mode: 'open'});
                    shadowRoot.innerHTML = item.html;
                    item.styles?.forEach((styleText) => {
                        const styleNode = document.createElement('style');
                        styleNode.textContent = styleText;
                        shadowRoot.appendChild(styleNode);
                        intersection.appendChild(spacer);
                    });
                    break;
            }

            // add intersection to list of products
            visibleProducts[item.pos - 1]?.before(intersection);

            switch (item.type) {
                case 'ProductCarouselComponent':
                    const dyCarousel = intersection.querySelector('.js-placeholder-dy-carousel');
                    intersection.querySelector('[data-ng-controller]')?.removeAttribute('data-ng-controller');

                    if (dyCarousel) {
                        const data = dyCarousel.dataset;
                        // OPTIMIZE: Algolia renders twice
                        $.ajax({
                            url: window.location.origin + ACC.config.encodedContextPath + '/view/ProductCarouselComponentController/' + data.id,
                            type: 'GET'
                        }).done(function (response) {
                            let $response = $(response);
                            if (data.showmoreurl) {
                                const $target = $response.find('.js-productcarousel-showmorebutton');
                                if (data.showmoretitle) {
                                    $target.attr('title', data.showmoretitle);
                                }
                                $target.attr('href', data.showmoreurl);
                                $target.removeClass('d-none');
                            }
                            item.html = $response.html();
                            $(intersection).find('.js-wishlist-controller').replaceWith($response.html());
                            // OPTIMIZE: create function
                            wishlistScope.$compile(intersection.querySelectorAll('.product__wishlist-cta'))(wishlistScope.$scope);
                            setTimeout(function () {
                                if (wishlistScope) {
                                    wishlistScope.$rootScope.$digest();
                                }
                                productCarousel.buildCarousel($(intersection).find('.js-carousel-lazy'));
                                if (wishlistScope) {
                                    wishlistScope.$rootScope.$broadcast('loadAlgoliaProductsSuccess');
                                }
                            }, 50);
                        }).fail(function (error) {
                            console.debug(`Cannot load ${data.id}`);
                        });
                    } else {
                        wishlistScope.$compile(intersection.querySelectorAll('.product__wishlist-cta'))(wishlistScope.$scope);
                        setTimeout(function () {
                            if (wishlistScope) {
                                wishlistScope.$rootScope.$digest();
                            }
                            productCarousel.buildCarousel($(intersection).find('.js-carousel, .js-carousel-lazy'));
                            if (wishlistScope) {
                                wishlistScope.$rootScope.$broadcast('loadAlgoliaProductsSuccess');
                            }
                        }, 50);
                    }
                    break;
                default:
                    break;
            }
        });
    }
};

$(() => {
    if (ACC.config.algolia.trackingEnabled === 'true') {
        let tracking = existsConsentCookie(algoliaTrackingConsentCookieName);
        let personalization = existsConsentCookie(algoliaPersonalizationConsentCookieName);
        algolia.initUpdateTracking(tracking, personalization);

        window.addEventListener('algolia-init-event', function (event) {
            let trackingNew = existsConsentCookie(algoliaTrackingConsentCookieName);
            let personalizationNew = existsConsentCookie(algoliaPersonalizationConsentCookieName);

            if (trackingNew !== tracking || personalizationNew !== personalization) {
                tracking = trackingNew;
                personalization = personalizationNew;
                algolia.initUpdateTracking(tracking, personalization);
            }
        });
        if ($('#checkout-summary-page').length) {
            sendPurchaseEvent();
        }
    }

    algolia.init();
});

export default algolia;
